import React from "react";
import { ErrorMessage } from "formik";

export default function PaymentVerificationComponent({ formik }) {
  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">Payment Verification</h4>

      {/* Info Box */}
      <div className="alert alert-info">
        <p className="mb-2">
          The registration fee of <strong>1000 LKR</strong> must be deposited to
          the following account:
        </p>
        <ul className="mb-0">
          <li>
            <strong>Bank:</strong> Peoples' Bank
          </li>
          <li>
            <strong>SWIFT Code:</strong> PSBKLKLX
          </li>
          <li>
            <strong>Branch:</strong> Galle Main Street
          </li>
          <li>
            <strong>Account Name:</strong> Old Boys Association Vidyaloka
            Vidyalaya
          </li>
          <li>
            <strong>Account Number:</strong> 169100180006180
          </li>
        </ul>
        <p className="mt-2 mb-0">
          The <strong>National Identity Card (NIC) number</strong> must be
          printed on the payment receipt as the{" "}
          <strong>
            reference, reason, remark, receiver’s comment, or narration{""}
          </strong>
          .
        </p>
      </div>

      {/* Warning Box */}
      <div className="alert alert-warning">
        <p className="mb-0">
          If the above details fail to verify, the registration request will be
          rejected.{" "}
          <strong>No refund will be provided under any circumstances.</strong>
        </p>
      </div>

      {/* Payment Slip Upload */}
      <div className="col-12 my-3">
        <label className="form-label">
          Upload Payment Slip<span className="text-danger">*</span>
        </label>
        <input
          type="file"
          className="form-control"
          accept="image/*,application/pdf"
          onChange={(e) =>
            formik.setFieldValue("paymentSlip", e.currentTarget.files[0])
          }
        />
        {formik.values.paymentSlip && (
          <small className="text-success">
            {formik.values.paymentSlip.name}
          </small>
        )}
        <ErrorMessage
          name="paymentSlip"
          component="div"
          className="text-danger"
        />
      </div>
    </div>
  );
}
